/**
 * Centralized token and session persistence management for PlannMe / RH-MVP.
 * Handles persistent storage (localStorage for Remember Me) and session storage
 * (sessionStorage for session-only login).
 */

export const getStoredToken = () => {
  try {
    return localStorage.getItem('token') || sessionStorage.getItem('token') || null;
  } catch (e) {
    console.error('Error accessing storage for token:', e);
    return null;
  }
};

export const setStoredToken = (token, rememberMe = false) => {
  try {
    if (rememberMe) {
      localStorage.setItem('token', token);
      sessionStorage.removeItem('token');
    } else {
      sessionStorage.setItem('token', token);
      localStorage.removeItem('token');
    }
  } catch (e) {
    console.error('Error writing token to storage:', e);
  }
};

export const removeStoredToken = () => {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user_id');
  } catch (e) {
    console.error('Error clearing storage:', e);
  }
};

export const getStoredUserId = () => {
  try {
    return localStorage.getItem('user_id') || sessionStorage.getItem('user_id') || null;
  } catch (e) {
    console.error('Error accessing storage for user_id:', e);
    return null;
  }
};

export const setStoredUserId = (userId, rememberMe = false) => {
  if (userId === null || userId === undefined) return;
  try {
    const idStr = String(userId);
    if (rememberMe) {
      localStorage.setItem('user_id', idStr);
      sessionStorage.removeItem('user_id');
    } else {
      sessionStorage.setItem('user_id', idStr);
      localStorage.removeItem('user_id');
    }
  } catch (e) {
    console.error('Error writing user_id to storage:', e);
  }
};

export const isRemembered = () => {
  try {
    return !!localStorage.getItem('token');
  } catch {
    return false;
  }
};
